// extracted by mini-css-extract-plugin
export default {"PokeSpriteCell":"PokeSpriteCell_PokeSpriteCell__J9LO+","PokeSpriteCell__emptySVG":"PokeSpriteCell_PokeSpriteCell__emptySVG__ZWTYO"};